var map = {
	"./canvas-hack-may-2026.png": 742,
	"./colonial-pipeline-2021.png": 63,
	"./iran-stryker-2026.png": 633,
	"./mercor-april-2026.png": 257,
	"./mgm-2025.png": 984,
	"./westjet-2026.png": 642,
	"./yahoo-2014.png": 615
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 204;